import { lzIsArray } from "../services/LzType";
import SubscriptionModel from "./subscription";

export default class PaymentModel {

    static TYPE_SUBSCRIPTION = 1;

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.id = model.id ? +model.id : 0;
        this.amount = model.amount ? +model.amount : 0;
        this.charged_at = model.charged_at ? model.charged_at : '';
        this.gateway_transaction_ref = model.gateway_transaction_ref ? model.gateway_transaction_ref : '';
        this.refunded_at = model.refunded_at ? model.refunded_at : '';
        this.created_at = model.created_at ? model.created_at : '';
        this.updated_at = model.updated_at ? model.updated_at : '';

        this.subscription = model.subscription ? new SubscriptionModel(model.subscription) : null;
    }

    static parseArray(data) {
        if (!lzIsArray(data)) {
            return [];
        }

        const out = [];
        for (const item of data) {
            out.push(new PaymentModel(item));
        }

        return out;
    }

}
